import React from 'react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-gradient-to-b from-brand-cream to-brand-lavender" data-id="element-101">
      <div className="max-w-4xl mx-auto text-center z-10 flex flex-col items-center" data-id="element-102">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-brand-lavenderDark/30 text-brand-purple text-sm font-semibold mb-8 tracking-wide" data-id="element-103">
          <span className="mr-2" data-id="element-104">✨</span> Protocolo respaldado por neurociencia
        </div>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-slate leading-tight mb-6" data-id="element-105">
          Recupera el mando: Cómo detener la ansiedad en 10 minutos sin depender
          de pastillas
        </h1>

        <h2 className="text-lg md:text-xl text-brand-navy max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-106">
          El protocolo biológico diseñado para mujeres de más de 50 años que
          necesitan apagar el interruptor del pánico y volver a dormir bajo sus
          propias reglas.
        </h2>

        <div className="bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-sm border border-brand-lavenderDark/20 max-w-3xl mx-auto mb-12 text-left" data-id="element-107">
          <p className="text-lg md:text-xl italic text-brand-slate mb-6 leading-relaxed" data-id="element-108">
            "Estás en la cama. Son las 3:14 AM. Tu corazón late como si
            estuvieras corriendo un maratón, pero estás inmóvil bajo las
            sábanas. Sientes un nudo en la garganta, las manos sudorosas y esa
            voz interna que te dice que esta vez vas a perder el control por
            completo."
          </p>
          <p className="text-base md:text-lg text-brand-navy leading-relaxed" data-id="element-109">
            No es falta de fuerza de voluntad. No es que te estés volviendo
            loca. Es tu sistema nervioso enviando una falsa alarma de incendio
            porque tus hormonas y tu cortisol han cambiado las reglas del juego
            después de los 50.
          </p>
        </div>

        <div className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-110">
          <a href="#comprar" className="w-full text-center bg-brand-coral hover:bg-brand-coralDark text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" aria-label="Click Aquí — Quiero recuperar mi paz mental" data-id="element-111">
            Quiero recuperar mi paz mental
            <br data-id="element-112" />
            <span className="text-lg md:text-xl" data-id="element-113">Click Aquí &rarr;</span>
          </a>
          <p className="mt-4 text-sm text-brand-navy font-medium flex items-center justify-center gap-2" data-id="element-114">
            <span aria-hidden="true" data-id="element-115">⚡</span> Descarga instantánea &middot;
            Pago 100% seguro
          </p>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-116">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-lavenderDark/20 blur-3xl" data-id="element-117"></div>
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[40%] rounded-full bg-brand-purple/10 blur-3xl" data-id="element-118"></div>
      </div>
    </section>;
}